const getCampaignNav = (campaign) => {
  return campaign ? [{
    _name: 'CSidebarNavDropdown',
    class: "hide-toggler",
    alwaysVisible: true,
    asLink: true,
    exact: true,
    name: campaign.name || campaign.id,
    to: `/campaigns/${campaign.id}/`,
    items: getCampaignNavItems(campaign)
  }] : undefined
  };

const getAdminNav = (userData, route) => {
  if (!userData.is_superuser) {
    return [];
  }
  return [
    {
      _name: "CSidebarNavItem",
      name: "Utilisateurs",
      to: "/admin/users",
    },
  ];
};

const getCampaignNavItems = (campaign) => {
  return [
    {
      exact: true,
      name: "Modèle d'Email",
      to: `/campaigns/${campaign.id}/mail`,
    },
    {
      exact: true,
      name: "Statistiques",
      to: `/campaigns/${campaign.id}/statistics`,
    }
  ]
}

const addActiveItemClass = (sidebarNav, route) => {
  return sidebarNav.map(n => {
    if (n.items) n.items = addActiveItemClass(n.items, route)
    if (n.exact ? route.path === n.to : route.path.startsWith(n.to)) {
      return {
        ...n,
        [n._class ? '_class' : 'class']: (n._class || n.class || "") + " item-active",
        addLinkClasses: "c-active font-weight-bold",
      }
    }
    else return n
  })
}

export const getSidebarNav = (route, campaign, showMail, userData) => {
  const tableItems = [
    {
      _name: "CSidebarNavItem",
      name: "Certifications / Titres",
      exact: false,
      to: "/certifications",
    },
    {
      _name: "CSidebarNavItem",
      name: "Fonctions",
      exact: false,
      to: "/fonctions",
    },
    {
      _name: "CSidebarNavItem",
      name: "Compétences",
      exact: false,
      to: "/competences",
    },
    {
      _name: "CSidebarNavItem",
      name: "Ecoles",
      exact: false,
      to: "/ecoles",
    },
    {
      _name: "CSidebarNavItem",
      name: "Secteur d'activité",
      exact: false,
      to: "/secteur",
    },
    {
      _name: "CSidebarNavItem",
      name: "Spécialité formation",
      exact: false,
      to: "/specialite",
    },
  ];

  const tablePaths = tableItems.map((item) => item.to);

  return [{
    _name: 'CSidebarNav',
    _children: addActiveItemClass([
      {
        _name: 'CSidebarNavDropdown',
        name: 'Campagnes',
        to: '/campaigns',
        alwaysVisible: true,
        asLink: true,
        exact: true,
        _class: "hide-toggler",
        items: getCampaignNav(campaign, route),
      },
      {
        _name: "CSidebarNavItem",
        name: "Génération de rapports",
        to: "/rapport",
      },
      {
        _name: "CSidebarNavItem",
        name: "Fichiers PBI Globaux",
        to: "/fichiers",
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Collecte données réseaux professionnels",
        to: "/linkedin",
        exact: true,
        alwaysVisible: true,
        asLink: true,
        items: [
          {
            name: "Fichiers Captain Data",
            to: "/fichiers-captain-data",
            exact: true,
          },
        ],
      },
      {
        _name: "CSidebarNavItem",
        name: "Alumni désinscrits",
        to: "/unsubscribed",
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Tables de référence",
        alwaysVisible: tablePaths.includes(route.path),
        _children: tableItems,
    },
      ...getAdminNav(userData, route),
    ], route),
  }]
};
